// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-SyncError-styles___paper--EI7P9 {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-BookingDetails-SyncError-styles___syncError--AWyqL {
  text-align: left;
  padding: 32px;
  margin-bottom: 32px;
}

.components-BookingDetails-SyncError-styles___syncError__title--o6oe7 {
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
    margin-top: 0;
    margin-bottom: 16px;
  }

.components-BookingDetails-SyncError-styles___syncError__container--jOd4W {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

.components-BookingDetails-SyncError-styles___syncError__information--E_fdJ {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

.components-BookingDetails-SyncError-styles___syncError__property--_ofDr {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 0px;
    margin-top: 0px;
  }

.components-BookingDetails-SyncError-styles___syncError__property__title--d_8jD {
      font-size: 14px;
      color: #6d717a;
      letter-spacing: 0;
    }

.components-BookingDetails-SyncError-styles___syncError__property__value--oFps9 {
      font-size: 14px;
      color: #1b2432;
      letter-spacing: 0;
      text-align: right;
    }

.components-BookingDetails-SyncError-styles___syncError__divider--IKX27 {
    border-bottom: 1px solid #c6c8cc;
    border-top: none;
    width: 100%;
    height: 0px;
  }

.components-BookingDetails-SyncError-styles___syncError__description--jvGrC {
    font-size: 14px;
    color: #1b2432;
    letter-spacing: 0;
  }
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/SyncError/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AAwDrB;;AAtDE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;AAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;EACb;;AAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;EAcjB;;AAZE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,iBAAiB;IACnB;;AAGF;IACE,gCAAgC;IAChC,gBAAgB;IAChB,WAAW;IACX,WAAW;EACb;;AAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.syncError {\n  text-align: left;\n  padding: 32px;\n  margin-bottom: 32px;\n\n  &__title {\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n    margin-top: 0;\n    margin-bottom: 16px;\n  }\n\n  &__container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n\n  &__information {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  &__property {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    margin-bottom: 0px;\n    margin-top: 0px;\n\n    &__title {\n      font-size: 14px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n\n    &__value {\n      font-size: 14px;\n      color: #1b2432;\n      letter-spacing: 0;\n      text-align: right;\n    }\n  }\n\n  &__divider {\n    border-bottom: 1px solid #c6c8cc;\n    border-top: none;\n    width: 100%;\n    height: 0px;\n  }\n\n  &__description {\n    font-size: 14px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-BookingDetails-SyncError-styles___paper--EI7P9`,
	"syncError": `components-BookingDetails-SyncError-styles___syncError--AWyqL`,
	"syncErrorTitle": `components-BookingDetails-SyncError-styles___syncError__title--o6oe7`,
	"syncErrorContainer": `components-BookingDetails-SyncError-styles___syncError__container--jOd4W`,
	"syncErrorInformation": `components-BookingDetails-SyncError-styles___syncError__information--E_fdJ`,
	"syncErrorProperty": `components-BookingDetails-SyncError-styles___syncError__property--_ofDr`,
	"syncErrorPropertyTitle": `components-BookingDetails-SyncError-styles___syncError__property__title--d_8jD`,
	"syncErrorPropertyValue": `components-BookingDetails-SyncError-styles___syncError__property__value--oFps9`,
	"syncErrorDivider": `components-BookingDetails-SyncError-styles___syncError__divider--IKX27`,
	"syncErrorDescription": `components-BookingDetails-SyncError-styles___syncError__description--jvGrC`
};
module.exports = ___CSS_LOADER_EXPORT___;
